module.exports = __webpack_public_path__ + "img/x.14e8f49a.jpeg";